import cn from 'classnames';
import { ReactComponent as GoBackSvg } from 'assets/img/go-back.svg';

import styles from './BackHeader.module.scss';

export type BackHeaderProps = {
  title: string;
  onBack: () => void;
  className?: string;
};

const BackHeader = ({ title, onBack, className }: BackHeaderProps) => {
  return (
    <button type="button" onClick={onBack} className={cn(styles.backButton, className)}>
      <div className={styles.navigationContainer}>
        <GoBackSvg className={styles.backIcon} />
      </div>
      <h1 className={styles.title}>{title}</h1>
    </button>
  );
};

export default BackHeader;
